import React from 'react'
import create from 'zustand'
import { pick } from 'lodash-es'
import createContext from 'zustand/context'
import shallow from 'zustand/shallow'
import { postStageNode } from '@vt/apis/lib-ex/v2/process'
import { useAppStore } from '../apps/app-store-provider'

const { Provider, useStore } = createContext()

const createStore = (appId) =>
  create((set, get) => {
    const setProcessNodes = (processNodes) => {
      set(() => ({ processNodes }))
    }
    const setCurrentNode = (currentNode) => {
      set(() => ({ currentNode }))
    }
    // 批量更新流程节点
    const batchUpdateStageNode = (updateData, selectedIds = []) => {
      const { currentNode } = get()
      // 所有选中数据挨个执行【操作节点】
      const arr = selectedIds.map((id) => {
        const obj = {
          objectId: id,
          identifyUuId: currentNode.uuid,
          stageId: currentNode.stageId,
        }
        return new Promise((resolve) => {
          postStageNode(appId, {
            ...obj,
            ...updateData,
          }).then((res) => {
            resolve(res)
          })
        })
      })

      return Promise.all(arr)
    }

    return {
      processNodes: [],
      setProcessNodes,
      currentNode: null,
      setCurrentNode,
      batchUpdateStageNode,
    }
  })
export const useBatchProcessStore = (selectors, equalityFn = shallow) =>
  useStore(selectors, equalityFn)

export const BatchProcessProvider = ({ children }) => {
  const { appId } = useAppStore((x) => pick(x, ['appId']))
  return (
    <Provider
      createStore={() => {
        return createStore(appId)
      }}
    >
      {children}
    </Provider>
  )
}
